const primaryColor = '#004298';

const styles = {
  background: {
    color: {
      primary: '#f1f1f1',
      secondary: primaryColor,
    },
  },
  color: {
    primary: primaryColor,
  },
  ids: {
    about: 'about',
    bsic: 'bsic',
    camps: 'camps',
    contacts: 'contacts',
    team: 'team',
    lang: 'lang',
    root: 'root',
  },
  link: {
    color: {
      primary: primaryColor,
      secondary: '#6FC4ED',
      third: '#FFF',
    },
  },
  title: {
    font: {
      primary: '"Roboto", "Helvetica", "Arial", sans-serif',
      secondary: 'Poppins',
      third: 'Diplomatas',
    },
    color: primaryColor,
  },
};

export { styles };
